import { SettingsCustomFormFieldData } from '../../../models/settings/settings-custom-form-field-data.class';
import { FieldDataInterface } from '../../../models/settings/settings-custom-form-field-data.model';

export class SettingsDynamicUrlLinkButtonV1Field extends SettingsCustomFormFieldData {

    // nueva propiedad para la URL personalizada
    public url?: string = '';
    public view?: boolean = false;
    public ready?: boolean = false; // when url are empty or correct

    public serialize(): FieldDataInterface {
        return this._serialize({
            url: this.url, 
            view: this.view
        });
    }

    public deserialize(field: FieldDataInterface): SettingsDynamicUrlLinkButtonV1Field {
        const self = new SettingsDynamicUrlLinkButtonV1Field(
            field.type,
            field.position,
            field.id,
            field.label,
            field.mandatory,
            field.active,
        );

        self.url = field.options.url;
        self.view = field.options.view;
        self.ready = self.validateUrl(field.options.url); // when url is '' or valid, it means that front validate url adn was saved.
        return self;
    }

    public update(updateData: Partial<SettingsDynamicUrlLinkButtonV1Field>): SettingsDynamicUrlLinkButtonV1Field {
        // Create a new instance with the initial data
        const self = new SettingsDynamicUrlLinkButtonV1Field(
            this.type,
            this.position,
            this.id,
            this.label,
            this.mandatory,
            this.active,
        );

        self.url = this.url;
        self.view = this.view;
        self.ready = self.validateUrl(self.url ?? '');
        // Apply any updates provided in updateData
        if (updateData) {
            Object.assign(self, updateData);
            // mark the field as changed    
            self.ready = self.validateUrl(self.url ?? '');
            self.changed = true;
        }

        return self;
    }

    /**
     * 
     * @param urlValue teh url given or got form api
     * @returns true if url is valid, false else.
     */
    public validateUrl(urlValue: string): boolean {
        // URL validation regex tested with google search in https://regex101.com/
        // const urlRegex = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})(\/[\w.-]*)*(\?[=&#%+\w.-]*)?\/?$/; // in case we permit specific chars in query: =&#%+
        const urlRegex = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})(\/[\w\-.={}]*)*(\?.*)?\/?$/i;
        // Check validity: No leading/trailing spaces and valid URL format and accept {PROJECTID} and {FORMID}
        return urlValue === urlValue.trim() && (urlValue !== '' && urlRegex.test(urlValue.toLowerCase()));
    }
}
